import Contact from './contact'
import ButtonLink from './contact/buttonLink'
import Title from './title'

const LeftContent = ({ title, instagram, email, whatsapp }) => {
  const base = 'w-full min-h-full max-w-[500px] flex flex-col justify-between'

  return (
    <div className={base}>
      <Title text={title} />
      <Contact>
        <ButtonLink
          title="Instagram"
          buttonName={instagram.name}
          buttonLink={instagram.link}
          target="_blank"
        />
        <ButtonLink
          title="Email"
          buttonName={email}
          buttonLink={`mailto:${email}`}
        />
        <ButtonLink
          title="Phone"
          buttonName={whatsapp.phoneNumber}
          buttonLink={whatsapp.link}
          target="_blank"
        />
      </Contact>
    </div>
  )
}

export default LeftContent
